import { IQuest, NextTimeStatus, QuestTypes, UserQuestStruct } from './daily-quests-page.types';

export function formatHMS(ms: number) {
  const clamp = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(clamp / 3600);
  const m = Math.floor((clamp % 3600) / 60);
  const s = clamp % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${pad(h)}:${pad(m)}:${pad(s)}`;
}

export function pickParts(res: any): { user: UserQuestStruct; bonusPoints: bigint } {
  if (res?.user && res?.bonusPoints !== undefined) {
    return { user: res.user as UserQuestStruct, bonusPoints: res.bonusPoints as bigint };
  }
  if (Array.isArray(res)) {
    return { user: res[1] as UserQuestStruct, bonusPoints: res[2] as bigint };
  }
  throw new Error('Malformed getUserInfo response');
}

export const convertToMs = (sec: bigint | number) => Number(sec) * 1000;

/**
 * Get the status of a quest based on its next available time.
 * @param nextTimeSec - The next available time in seconds.
 * @returns The status of the quest.
 * If nextTimeSec === 0 then the quest is ready
 * If nextTimeSec > 0 then the quest is done and we set it to Cooldown
 * Otherwise, the quest is in progress
 */
export const statusFromNextTime = (nextTimeSec: bigint | number) => {
  // const ms = Number(nextTimeSec) * 1000;
  // if (!nextTimeSec || Number(nextTimeSec) === 0) return NextTimeStatus.Ready;
  return Date.now() >= convertToMs(nextTimeSec) ? NextTimeStatus.Ready : NextTimeStatus.Cooldown;
};

export const guestUser: UserQuestStruct = {
  nextDailyQuestTime: BigInt(0),
  nextDailyGameTime: BigInt(0),
  nextDailyWinTime: BigInt(0),
  weekStreak: BigInt(0),
};

export const autoRequestKey = (chainId?: number, address?: string) =>
  `dq:autoClaimDaily:${chainId ?? 0}:${(address ?? '').toLowerCase()}`;

export const withPrizeCratePoints = (
  items: IQuest[],
  dollars: number,
): { next: IQuest[]; changed: boolean } => {
  if (!items?.length) return { next: items, changed: false };

  let changed = false;
  const next = items.map((q) => {
    if (q.id !== QuestTypes.DailyPrizeCrate) return q;
    if (q.points !== dollars) {
      changed = true;
      return { ...q, points: dollars };
    }
    return q;
  });

  return { next, changed };
};
